/* eslint-disable */

export enum ProductListType {
	Normal = 0,
	Brand = 1,
	CategoryFilter = 2,
	BrandCategoryFilter = 3,
	Search = 4,
	
}
